import React, { FC } from "react";
import { Icon } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { declension } from "../../../../utils/declension";
import { ImportSuccessContainer } from "../styled";
import { CopyTaskMessage } from "../../CopyResource/components/Layer/styled";

export const ImportSuccess: FC<{ objectCount: number; totalCount: number }> = ({ objectCount, totalCount }) => {
  const { t, i18n } = useTranslation();

  return (
    <ImportSuccessContainer>
      <Icon kind="success" />
      <div>
        {t("actions.ready", { ns: "common" })}
        <CopyTaskMessage success>
          <>
            {i18n.language === "en" ? (
              <>
                {objectCount} from {totalCount} {objectCount === 1 ? "object" : "objects"} uploaded
              </>
            ) : (
              <>
                {declension("Загружен", "Загружено", "Загружено", objectCount)}
                &nbsp;{objectCount} из {totalCount}&nbsp;
                {declension("объект", "объектов", "объекта", objectCount)}
              </>
            )}
          </>
        </CopyTaskMessage>
      </div>
    </ImportSuccessContainer>
  );
};
